var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-btn" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("清除资产单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.clearVoucher, rules: _vm.voucherInfo }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("清除机构")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "bizUnitId",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.clearVoucher.bizUnitName,
                          callback: function($$v) {
                            _vm.$set(_vm.clearVoucher, "bizUnitName", $$v)
                          },
                          expression: "clearVoucher.bizUnitName"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.srcCheck
                        ? _c("i", {
                            staticClass:
                              "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                            on: { click: _vm.selectBizUnitName }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("清除日期")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "theDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: { type: "date", placeholder: "选择日期" },
                        model: {
                          value: _vm.clearVoucher.theDate,
                          callback: function($$v) {
                            _vm.$set(_vm.clearVoucher, "theDate", $$v)
                          },
                          expression: "clearVoucher.theDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("审核单号")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "auditPoofNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入单号",
                          disabled: _vm.srcCheck
                        },
                        model: {
                          value: _vm.clearVoucher.auditPoofNo,
                          callback: function($$v) {
                            _vm.$set(_vm.clearVoucher, "auditPoofNo", $$v)
                          },
                          expression: "clearVoucher.auditPoofNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.showBizUnitWarehouse && !_vm.srcCheck
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("仓库名称")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "warehouseId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.compareIn },
                              model: {
                                value: _vm.clearVoucher.warehouseId,
                                callback: function($$v) {
                                  _vm.$set(_vm.clearVoucher, "warehouseId", $$v)
                                },
                                expression: "clearVoucher.warehouseId"
                              }
                            },
                            _vm._l(_vm.wareHouseList, function(item) {
                              return _c("el-option", {
                                attrs: { label: item.name, value: item.id }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      !_vm.srcCheck
        ? _c("div", { staticClass: "simple-row" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.showDeviceListDlg()
                      }
                    }
                  },
                  [_c("span", [_vm._v("通用选择")])]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _vm.clearVoucher.deviceItemList != null
            ? _c("span", [
                _vm._v(
                  "已选择(" +
                    _vm._s(_vm.clearVoucher.deviceItemList.length) +
                    ")"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.clearVoucher.deviceItemList != null &&
          _vm.clearVoucher.deviceItemList.length > 0
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-primary",
                  on: { click: _vm.setStaff }
                },
                [_vm._v("设置人员")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.clearVoucher.deviceItemList != null &&
          _vm.clearVoucher.deviceItemList.length > 0 &&
          !_vm.srcCheck
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-primary",
                  on: {
                    click: function($event) {
                      _vm.selectDeviceClearDeasc()
                    }
                  }
                },
                [_vm._v("清除原因")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table-layout",
          staticStyle: { width: "100%", "overflow-x": "auto" }
        },
        [
          _c(
            "el-form",
            { ref: "deviceInfo", attrs: { model: _vm.clearVoucher } },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "180" }
                      },
                      [_vm._v("资产描述全称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "180" }
                      },
                      [_vm._v("名称")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "150" }
                      },
                      [_vm._v("型号")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "150" }
                      },
                      [_vm._v("规格")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "250" } }, [_vm._v("系统编号")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "150" } }, [
                      _vm._v("外部系统编号")
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "250" } }, [
                      _vm._v("商品标识码")
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "100" }
                      },
                      [_vm._v("分类")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "100" }
                      },
                      [_vm._v("分类分组")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "120" }
                      },
                      [_vm._v("品牌")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { width: "90" }
                      },
                      [_vm._v("财务类别")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { width: "90" }
                      },
                      [_vm._v("入账方式")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "130" } }, [_vm._v("清除部门")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "100" } }, [_vm._v("清除人")]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "160" }
                      },
                      [_vm._v("批次号")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "250" } }, [_vm._v("资产编号")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "80" } }, [_vm._v("在库数量")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "80" } }, [
                      _vm._v("财务在账数量")
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "80" } }, [
                      _vm._v("可清除数量")
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "80" } }, [_vm._v("清除数量")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "80" } }, [_vm._v("单位")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "100" } }, [_vm._v("清理费用")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "100" } }, [_vm._v("清理收入")]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "120" } }, [_vm._v("清除原因")]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "120" }
                      },
                      [_vm._v("备注")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { width: "120" }
                      },
                      [_vm._v("管理方式")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "120" } }, [_vm._v("操作")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  _vm._l(_vm.clearVoucher.deviceItemList, function(
                    deviceItem,
                    index
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.title))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.name))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.model))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.fixedSpec))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.tmpNo))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.innerNo))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.vendorUkno))]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.catName))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.devcGroupFullName))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.brandName))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.assetKindName))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm.acctEnterWayMap[deviceItem.acctEnterWay])
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.departName))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.staffName))]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.batchNo))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.innerCode))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.inStkQuantity))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(deviceItem.fiscalQuantity))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              deviceItem.fiscalAcctFlag == 0
                                ? deviceItem.inStkQuantity
                                : deviceItem.inStkQuantity <
                                  deviceItem.fiscalOutQuantity -
                                    deviceItem.clearedQuantity
                                ? deviceItem.inStkQuantity
                                : deviceItem.fiscalOutQuantity -
                                  deviceItem.clearedQuantity
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          deviceItem.assetType == 0
                            ? [_vm._v("1")]
                            : [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "deviceItemList." +
                                        index +
                                        ".clearAvQuantity",
                                      rules: {
                                        validator: _vm.inputClearQuantity,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-content-right",
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        disabled: _vm.srcCheck
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(deviceItem)
                                        }
                                      },
                                      model: {
                                        value: deviceItem.clearAvQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            deviceItem,
                                            "clearAvQuantity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "deviceItem.clearAvQuantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(deviceItem.theUnit))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "deviceItemList." + index + ".theFee",
                                rules: {
                                  validator: _vm.inputTheFee,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-content-left",
                                attrs: { type: "text" },
                                model: {
                                  value: deviceItem.theFee,
                                  callback: function($$v) {
                                    _vm.$set(deviceItem, "theFee", $$v)
                                  },
                                  expression: "deviceItem.theFee"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "deviceItemList." + index + ".theInc",
                                rules: {
                                  validator: _vm.inputTheInc,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-content-left",
                                attrs: { type: "text" },
                                model: {
                                  value: deviceItem.theInc,
                                  callback: function($$v) {
                                    _vm.$set(deviceItem, "theInc", $$v)
                                  },
                                  expression: "deviceItem.theInc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          deviceItem.checked == true
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.srcCheck
                                  },
                                  model: {
                                    value: deviceItem.clearCause,
                                    callback: function($$v) {
                                      _vm.$set(deviceItem, "clearCause", $$v)
                                    },
                                    expression: "deviceItem.clearCause"
                                  }
                                },
                                _vm._l(_vm.devcClearCauseList, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.text,
                                      value: item.value
                                    }
                                  })
                                })
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          _c("el-input", {
                            staticClass: "textarea-value",
                            attrs: { type: "textarea" },
                            model: {
                              value: deviceItem.memo,
                              callback: function($$v) {
                                _vm.$set(deviceItem, "memo", $$v)
                              },
                              expression: "deviceItem.memo"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            deviceItem.assetType == 0
                              ? "单品式管理"
                              : "批量式管理"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        !_vm.srcCheck
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeDeviceItem(index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.setStaffInfo(index)
                              }
                            }
                          },
                          [_vm._v("设置人员")]
                        )
                      ])
                    ])
                  })
                ),
                _vm._v(" "),
                _vm.clearVoucher.deviceItemList == null ||
                _vm.clearVoucher.deviceItemList.length == 0
                  ? _c("tfoot", { staticClass: "foot" }, [
                      _c("tr", { staticClass: "row" }, [
                        _c("td", { attrs: { colspan: "18" } }, [
                          _c("span", { staticClass: "block font-gray3" }, [
                            _vm._v("请选择资产")
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.clearVoucher.memo,
                  callback: function($$v) {
                    _vm.$set(_vm.clearVoucher, "memo", $$v)
                  },
                  expression: "clearVoucher.memo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.saveDeviceIoVoucher }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("清除信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-tip error fr font12" }, [
        _vm._v("提示:一次清除数据最多500条")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "input-tip error" }, [
        _vm._v(
          "提示:资产如果在套装中,将解除关联套装,如果资产是套装主资产则套装将解散。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附加信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1033a35a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1033a35a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/clearVoucher/ShopDeviceClearVoucherSave.vue
// module id = 2592
// module chunks = 0